// FP3-122 §17-22 — Canonical date-only helpers. Progress surfaces
// never accept UTC-midnight parsing; dates are DATE-ONLY values.
import { parseDateOnly, formatMonthDay } from "@/lib/dateOnly";

// Helpers shared across Progress views.
export const TREND_META = {
  improving: { label: "Improving", text: "#4A6B52", bg: "#E4EFE7", border: "#89B498", dot: "#5A8A6A" },
  declining: { label: "Declining", text: "#B85C5C", bg: "#FDF2F2", border: "#E0A4A4", dot: "#B85C5C" },
  plateauing: { label: "Plateauing", text: "#7D6340", bg: "#FDF8F3", border: "#D9A05B", dot: "#D9A05B" },
  stable: { label: "Stable", text: "#3D5F82", bg: "#EDF2F7", border: "#7B9FC0", dot: "#4A6B8C" },
  sparse: { label: "Sparse data", text: "#6B7280", bg: "#F3F1EC", border: "#D4D2CC", dot: "#9B9890" },
  no_data: { label: "No data", text: "#6B7280", bg: "#F3F1EC", border: "#D4D2CC", dot: "#9B9890" },
};

export const FLAG_META = {
  declining: { label: "Declining", text: "#B85C5C", bg: "#FDF2F2" },
  plateauing: { label: "Plateauing", text: "#7D6340", bg: "#FDF8F3" },
  stale_data: { label: "Stale data", text: "#7D6340", bg: "#FDF8F3" },
  no_data: { label: "No data", text: "#6B7280", bg: "#F3F1EC" },
  sparse: { label: "Sparse", text: "#6B7280", bg: "#F3F1EC" },
  improving: { label: "Improving", text: "#4A6B52", bg: "#E4EFE7" },
  at_target: { label: "At target", text: "#3D5F82", bg: "#EDF2F7" },
};

export const fmtDate = (s) => {
  if (!s) return "—";
  return formatMonthDay(s);
};

export const daysSince = (dateStr) => {
  if (!dateStr) return null;
  const d = parseDateOnly(dateStr);
  if (!d) return null;
  const now = new Date();
  now.setHours(0, 0, 0, 0);
  d.setHours(0, 0, 0, 0);
  return Math.floor((now - d) / (1000 * 60 * 60 * 24));
};
